import { render, staticRenderFns } from "./ViewerPageDesign.vue?vue&type=template&id=3b0ae0a8&scoped=true"
import script from "./ViewerPageDesign.vue?vue&type=script&lang=js"
export * from "./ViewerPageDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerPageDesign.vue?vue&type=style&index=0&id=3b0ae0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ae0a8",
  null
  
)

export default component.exports